import React from 'react';

const PoweredByOtoStolik = () => <div className="d-flex flex-row align-items-end justify-content-center mt-2">
  <small className="mr-2">we współpracy z:</small>
  <a href="otostolik.pl">
    <img src="https://otostolik.pl/storage/img/logo-svg/with-pl-light.svg" alt="Logo OtoStolik.pl" style={{ width: 100 }} />
  </a>
</div>;

export default PoweredByOtoStolik;
